import {
  initialState,
  Actions,
  State,
  DELETE_INSPECTION,
  DELETE_INSPECTION_SUCCESS,
  DELETE_INSPECTION_ERROR,
  RESET_DELETE_INSPECTION,
} from '../../types/inspection/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_INSPECTION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_INSPECTION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_INSPECTION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_INSPECTION:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
